<template>
  <div id="email" class="tab-pane">
    <LogFilterBox @apply="getEmailLogs(1)" @clear="clearSearch">
      <div class="form-row align-items-end">
        <div class="col-12 col-md-6">
          <label for="subject" class="form-label">{{
            trans("admin.logFilterSubject")
          }}</label>
          <input
            id="subject"
            v-model="searchFields.subject"
            type="text"
            class="form-control"
            name="subject"
          />
        </div>
        <div class="col-12 col-md-6">
          <label for="body" class="form-label">{{
            trans("admin.logFilterBody")
          }}</label>
          <input
            id="body"
            v-model="searchFields.body"
            type="text"
            class="form-control"
            name="body"
          />
        </div>
      </div>

      <div class="form-row align-items-end mt-3">
        <div class="col-12 col-md-6">
          <label for="to" class="form-label">{{
            trans("admin.logFilterEmailAddress")
          }}</label>
          <input
            id="to"
            v-model="searchFields.to"
            type="text"
            class="form-control"
            name="to"
            data-test="email-log-to-filter"
          />
        </div>
        <div class="col-12 col-md-6">
          <label for="username" class="form-label">{{
            trans("forms.username")
          }}</label>
          <input
            id="username"
            v-model="searchFields.username"
            type="text"
            class="form-control"
            name="username"
          />
        </div>
      </div>

      <div class="form-row align-items-end mt-3">
        <div class="col-12 col-md-6">
          <label class="form-label">{{
            trans("evaluation.tableColumnCreatedAtFrom")
          }}</label>
          <custom-datepicker
            :date="searchFields.dateFrom"
            :placeholder="trans('evaluation.tableColumnCreatedAtFrom')"
            @on-date-change="changeDates('dateFrom', $event)"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">{{
            trans("evaluation.tableColumnCreatedAtTo")
          }}</label>
          <custom-datepicker
            :date="searchFields.dateUntil"
            :placeholder="trans('evaluation.tableColumnCreatedAtTo')"
            @on-date-change="changeDates('dateUntil', $event)"
          />
        </div>
      </div>
    </LogFilterBox>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>#</th>
            <th>{{ trans("admin.logColumnTo") }}</th>
            <th>{{ trans("admin.logColumnUser") }}</th>
            <th>{{ trans("admin.logColumnSubject") }}</th>
            <th>{{ trans("admin.logColumnDate") }}</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, index) in email.logs"
            :key="index"
            data-test="email-log-row"
          >
            <td>{{ log.id }}</td>
            <td>{{ log.to }}</td>
            <td>{{ log.user }}</td>
            <td>{{ log.subject }}</td>
            <td>{{ log.created_at_formatted }}</td>
            <td>
              <a
                data-toggle="modal"
                data-target="#emailBody"
                aria-hidden="true"
                class="btn"
                @click="showEmailBody(log.body)"
                >{{ trans("admin.emailLogShowBody") }}</a
              >
            </td>
            <td>
              <a
                data-toggle="modal"
                data-target="#emailHeaders"
                aria-hidden="true"
                class="btn"
                @click="showEmailHeaders(log.headers)"
                >{{ trans("admin.emailLogShowHeaders") }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid pull-right">
      <DerPaginate
        v-model="paginate.current_page"
        :page-count="paginate.last_page"
        :show-go="true"
        @change="getEmailLogs"
      />
    </div>

    <div
      id="emailBody"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body" style="text-align: center">
            <iframe height="700" width="600" :srcdoc="emailBody" />
          </div>
        </div>
      </div>
    </div>

    <div
      id="emailHeaders"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <span style="white-space: pre">{{ emailHeaders }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../design-system/DerPaginate.vue";
import LogFilterBox from "./LogFilterBox.vue";
import { queryStringBuilder } from "../../../helpers/misc";

export default {
  components: { DerPaginate, LogFilterBox },
  data() {
    return {
      loading: true,
      paginate: {
        current_page: 0,
        total: 0,
        last_page: 0,
      },
      email: {
        logs: [],
      },
      searchFields: {
        subject: "",
        to: "",
        username: "",
        body: "",
        dateFrom: "",
        dateUntil: "",
        page: 1,
      },
      emailBody: "",
      emailHeaders: "",
    };
  },
  created: function () {
    this.getEmailLogs(1);
  },
  methods: {
    getEmailLogs(page) {
      this.loading = true;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.searchFields.page = page ? page : this.searchFields.page;
      axios
        .get(
          "/api/internal/admin/logs/email?" +
            queryStringBuilder(this.searchFields),
        )
        .then((data) => {
          const collection = data.data;
          this.paginate = collection.paginate;
          this.email.logs = collection.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    showEmailBody: function (body) {
      this.emailBody = body;
    },
    showEmailHeaders: function (headers) {
      this.emailHeaders = headers;
    },
    clearSearch: function () {
      Object.assign(
        this.$data.searchFields,
        this.$options.data.call(this).searchFields,
      );
      this.getEmailLogs(1);
    },
    changeDates: function (target, date) {
      if (target === "dateFrom") {
        this.searchFields.dateFrom = date;
      } else {
        this.searchFields.dateUntil = date;
      }
    },
  },
};
</script>
